module.exports = __webpack_public_path__ + "img/logo.84ca4a0a.png";